// extracted by mini-css-extract-plugin
export default {"wrap":"InfoTooltip_wrap__wJPsb","icon":"InfoTooltip_icon__WPVdL","bubble":"InfoTooltip_bubble__qyAVk"};